/**
 * Push subscriptions API client (Phase 11 / M9).
 *
 * Mirrors the gateway routes in `apps/chaos-gateway/src/routes/push.ts`.
 * Keys are colocated with `pushKeys` so React Query consumers can
 * invalidate / refetch the listing without referring to magic strings.
 */
import { apiJson } from './client';

export interface PushSubscriptionRow {
  id: string;
  endpoint: string;
  userAgent: string | null;
  createdAt: string;
  lastSeenAt: string;
  revoked: boolean;
}

export interface VapidKeyInfo {
  configured: boolean;
  publicKey: string;
}

export const pushKeys = {
  list: () => ['push', 'subscriptions'] as const,
  vapid: () => ['push', 'vapid'] as const,
} satisfies Record<string, (...args: never[]) => readonly unknown[]>;

export const pushApi = {
  listSubscriptions: () => apiJson<PushSubscriptionRow[]>('/push/subscriptions'),
  vapidKey: () => apiJson<VapidKeyInfo>('/push/vapid-key'),
};
